import { render, staticRenderFns } from "./chanyeYQ.vue?vue&type=template&id=5ed0cd56&scoped=true"
import script from "./chanyeYQ.vue?vue&type=script&lang=js"
export * from "./chanyeYQ.vue?vue&type=script&lang=js"
import style0 from "./chanyeYQ.vue?vue&type=style&index=0&id=5ed0cd56&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed0cd56",
  null
  
)

export default component.exports